import { useCallback, useEffect, useRef, useState } from "react";
import MuxPlayer from "@mux/mux-player-react";
import "./MediaChannelVOD.scss";

export default function MediaChannelVOD(props) {
  const playerRef = useRef(null);
  const [src, setSrc] = useState(null);

  const handleDone = useCallback(() => props.done(), [props.done]);
  const handleError = useCallback((e) => props.error(e), [props.error]);
  const handleProgress = useCallback(() => { if (props.playerError) props.solveError(); }, [props.playerError, props.solveError]);

  useEffect(() => {
    const muxEl = playerRef.current;
    if (!muxEl) return;

    const forwardError = (err) => handleError(err || { message: "Unknown error" });
    const onMuxError = (e) => {
      const err = e?.detail || e;
      const fatal = err?.fatal || err?.data?.fatal || err?.code === 2 || err?.details === "manifestParsingError" || err?.reason === "no levels found in manifest";
      if (fatal) forwardError(err);
    };
    muxEl.addEventListener("error", onMuxError);

    let hlsAttached = false, cancel = false;
    const tryAttachHls = () => {
      if (cancel || hlsAttached) return;
      if (muxEl.hls && window.Hls && muxEl.hls.on) {
        muxEl.hls.on(window.Hls.Events.ERROR, (_evt, data) => data?.fatal && forwardError({ message: `${data.type}:${data.details}`, ...data }));
        hlsAttached = true;
        setSrc(props.vodUrl || null);
      }
    };

    const poll = setInterval(tryAttachHls, 30);
    const to = setTimeout(() => { clearInterval(poll); cancel = true; setSrc(props.vodUrl || null); }, 500);

    const onUnhandled = (ev) => forwardError({ message: ev?.reason || "unhandledrejection" });
    window.addEventListener("unhandledrejection", onUnhandled);

    return () => {
      muxEl.removeEventListener("error", onMuxError);
      window.removeEventListener("unhandledrejection", onUnhandled);
      clearInterval(poll);
      clearTimeout(to);
      setSrc(null);
    };
  }, [props.vodUrl, handleError]);

  return (
    <MuxPlayer
      ref={playerRef}
      className="MediaChannelVOD"
      src={src}
      type="application/vnd.apple.mpegurl"
      streamType="on-demand"
      playsInline
      autoplay
      onEnded={handleDone}
      onError={handleError}
      onTimeUpdate={handleProgress}
      style={{ width: "100%", height: "100%", "--controls": "none" }}
    />
  );
}
